module.exports = __webpack_public_path__ + "images/stickers/thumbsdown@2x.79d155c5163ee1a67509.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/thumbsdown@2x.png
// module id = C7td
// module chunks = 0